export default __webpack_public_path__ + "static/media/icono.0595dd9e.png";